module.exports = __webpack_public_path__ + "img/large_1-678.9f2f7514.png";